import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnDrawer as UICnDrawer } from './drawer';
import { CnDrawerFooter } from './footer';
import { CnDrawerHeader } from './header';
import './styles/index.scss';
function attachPropertiesToComponent(component, properties) {
    const ret = component;
    for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            ret[key] = properties[key];
        }
    }
    return ret;
}
const Drawer = withI18n(UICnDrawer, { locale, _noHoc: true });
const CnDrawer = attachPropertiesToComponent(Drawer, {
    Header: CnDrawerHeader,
    Footer: CnDrawerFooter,
});
CnDrawer.displayName = 'CnDrawer';
export { CnDrawer };
